export default { sha: 'be08d707ed94001437c09ca8fa78f42fee6af0f2', buildNumber: 'undefined' }
